import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import styles from './AcidAnswer.module.scss';
import classNames from 'classnames';
import VocabularWord from './VocabularWord';

export default class AcidAnswer extends Component {
    static propTypes = {};

    render() {
        return (
            <Fragment>
                <div className={styles.acidAnswer}>
                    <b>
                        But… Being mean isn’t <i>always</i> bullying.
                    </b>
                    <div>
                        It could be a mean moment... a bad day... or a misunderstanding.
                        If you’re wondering if something is bullying, it has to fully pass
                        the ACID test:
                    </div>
                </div>
                <ul className={styles.acidList}>
                    <li className={styles.acidItem}>Aggressive</li>
                    <li className={styles.acidItem}>Continual</li>
                    <li className={styles.acidItem}>
                        Imbalance of Power <br />
                        (One person being stronger socially, physically, or mentally)
                    </li>
                    <li className={styles.acidItem}>
                        <VocabularWord word='Deliberate'>
                            {highlight => (
                                <Fragment>
                                    {highlight('Deliberate:')} (adjective) done
                                    consciously and intentionally:{' '}
                                    <i>a deliberate attempt to provoke conflict.</i>
                                </Fragment>
                            )}
                        </VocabularWord>
                    </li>
                </ul>
            </Fragment>
        );
    }
}
